<template>
  <div :dir="$functions.currentLangDirection()">
    <b-card
      class="devicesList d-md-block ddm-card"
      style="overflow-x: hidden;width: 100vw;
            height: calc( 100vh - 50px);
            padding: 0 !important;
            margin: 0 !important;
            top: 0 !important;
            left: 0 !important;
            position: absolute;"
    >
      <v-row style="background: #00abfd; margin: 0;">
        <v-col
          cols="8"
          md="8"
          style="padding-top: 2px;padding-bottom: 2px;"
        >
          <v-text-field
            v-model="listQuery"
            dark
            color="#fff"
            prepend-inner-icon="mdi-magnify"
            label="جستجوی نام، شناسه یا سیم‌کارت"
            class="searchDeviceInput"
            clearable
            hide-details
          />
        </v-col>
        <v-col
          cols="4"
          md="4"
          style="padding-right: 0;padding-top: 0;padding-bottom: 0px;"
        >
          <b-button
            v-if="mobile != '09120000000'"
            variant="gradient-light"
            style="position: absolute;top: 14px;color: #fff;padding-right: 5px;padding-left: 0;"
            class="btn addDeviceBtn"
            @click="onAddDeviceClick()"
          >
            <feather-icon
              icon="PlusIcon"
              size="16"
            /> ثبت دستگاه
          </b-button>
        </v-col>
      </v-row>
      <div class="dd-chips">
        <button
          v-for="c in statusChips"
          :key="c.value"
          class="dd-chip"
          :class="{ 'dd-chip-on': statusFilter === c.value }"
          @click="statusFilter = c.value"
        >
          <span
            v-if="c.color"
            class="dd-chipdot"
            :style="{ background: c.color }"
          />{{ c.label }}
        </button>
      </div>
      <div class="dd-list ddm-list">
        <div
          v-if="listLoading"
          class="dd-skel-wrap"
        >
          <div
            v-for="n in itemsPerPage"
            :key="'sk' + n"
            class="dd-skel"
          >
            <div class="dd-skel-ava" />
            <div class="dd-skel-lines">
              <div class="dd-skel-bar" style="width:55%" />
              <div class="dd-skel-bar" style="width:80%;height:18px" />
              <div class="dd-skel-bar" style="width:40%" />
            </div>
          </div>
        </div>
        <template v-else-if="pagedDevices.length">
          <device-row
            v-for="item in pagedDevices"
            :key="item.imei"
            :device="item"
            :menu-items="menuItems"
            @select="rowSelect"
            @action="onMenuAction"
            @renew="rowRenew"
          />
        </template>
        <div
          v-else
          class="dd-empty"
        >
          <v-icon
            size="42"
            color="#c4c8d4"
          >
            {{ (desserts && desserts.length) ? 'mdi-magnify-close' : 'mdi-car-off' }}
          </v-icon>
          <p class="dd-empty-txt">
            {{ (desserts && desserts.length) ? 'موردی با این جستجو/فیلتر پیدا نشد' : 'خودرویی برای نمایش نیست' }}
          </p>
        </div>
      </div>
      <div
        v-if="!listLoading && pageCountDeviceTable > 1"
        class="dd-pager"
      >
        <button
          class="dd-pbtn dd-pbtn-wide"
          :disabled="pageDeviceTable <= 1"
          @click="goPage(pageDeviceTable - 1)"
        >
          قبلی
        </button>
        <template v-for="(p, i) in pagerItems">
          <span
            v-if="p === '...'"
            :key="'e' + i"
            class="dd-pellipsis"
          >…</span>
          <button
            v-else
            :key="'p' + p"
            class="dd-pbtn"
            :class="{ 'dd-pbtn-on': p === pageDeviceTable }"
            @click="goPage(p)"
          >
            {{ faDigits(p) }}
          </button>
        </template>
        <button
          class="dd-pbtn dd-pbtn-wide"
          :disabled="pageDeviceTable >= pageCountDeviceTable"
          @click="goPage(pageDeviceTable + 1)"
        >
          بعدی
        </button>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BLink, BButton, BCard, BCardText, BCardBody,
} from 'bootstrap-vue'
import Vue from 'vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import router from '@/router'
import UserService from '@/services/user.service'
import deviceService from '@/services/device.service'
import { getUserData } from '@/auth/utils'
import DeviceRow from '@/views/Home/components/DeviceRow.vue'
import { deviceDisplay } from '@/utils/deviceDisplay'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BLink, BButton, BCard, BCardText, BCardBody, DeviceRow,
  },
  data() {
    return {
      mobile: getUserData().mobile,
      desserts: Vue.prototype.$devices,
      pageDeviceTable: 1,
      itemsPerPage: 4,
      search: '',
      listQuery: '',
      statusFilter: '',
      listLoading: true,
      statusChips: [
        { value: '', label: 'همه', color: '' },
        { value: 'move', label: 'در حرکت', color: '#28c76f' },
        { value: 'park', label: 'پارک', color: '#ff9f43' },
        { value: 'off', label: 'آفلاین', color: '#a8b1bd' },
        { value: 'exp', label: 'منقضی', color: '#ea5455' },
      ],
      menuItems: [
        { title: 'جزییات', icon: 'mdi-file-document-outline', action: 'detail' },
        { title: 'دستورات', icon: 'mdi-cog', action: 'command' },
        { title: 'سابقه حرکت', icon: 'mdi-map-marker-path', action: 'history' },
      ],
    }
  },
  watch: {
    desserts(val) {
      if (val && val.length) this.listLoading = false
    },
    listQuery() {
      this.pageDeviceTable = 1
    },
    statusFilter() {
      this.pageDeviceTable = 1
    },
  },
  computed: {
    totalRecords() {
      return this.filteredDevices.length
    },
    filteredDevices() {
      const toLatin = s => String(s || '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
      const q = toLatin(this.listQuery).trim().toLowerCase()
      const status = this.statusFilter
      return (this.desserts || []).filter(item => {
        if (q) {
          const title = String(item.title || '').toLowerCase()
          const imei = toLatin(item.imei).toLowerCase()
          const sim = toLatin(item.sim).toLowerCase()
          if (!title.includes(q) && !imei.includes(q) && !sim.includes(q)) return false
        }
        if (status) {
          const kind = deviceDisplay(item).kind
          if (status === 'move' && !(kind === 'move' || kind === 'tow')) return false
          if (status === 'park' && !(kind === 'park' || kind === 'idle')) return false
          if (status === 'off' && kind !== 'off') return false
          if (status === 'exp' && kind !== 'exp') return false
        }
        return true
      })
    },
    pagedDevices() {
      const per = this.itemsPerPage
      const start = (this.pageDeviceTable - 1) * per
      return this.filteredDevices.slice(start, start + per)
    },
    pagerItems() {
      const total = this.pageCountDeviceTable
      const cur = this.pageDeviceTable
      if (total <= 5) {
        const all = []
        for (let i = 1; i <= total; i += 1) all.push(i)
        return all
      }
      const win = 3
      let start = Math.max(2, cur - 1)
      const end = Math.min(total - 1, start + win - 1)
      start = Math.max(2, end - win + 1)
      const items = [1]
      if (start > 2) items.push('...')
      for (let i = start; i <= end; i += 1) items.push(i)
      if (end < total - 1) items.push('...')
      items.push(total)
      return items
    },
    pageCountDeviceTable() {
      return Math.max(1, Math.ceil(this.totalRecords / this.itemsPerPage))
    },
    headers() {
      return [
        {
          text: 'Category',
          align: 'start',
          sortable: false,
          value: 'category',
          width: '45px',
        },
        {
          text: 'Title',
          align: 'start',
          value: 'title',
          width: '50%',
        },
        {
          text: 'Communication status',
          align: 'start',
          value: 'onlineStatus',
        },
        {
          text: 'Movement status',
          align: 'start',
          value: 'serverStatus',
        },
        {
          text: 'Satellite status',
          align: 'start',
          value: 'serverInfo',
        },
        {
          text: 'Options',
          align: 'start',
          value: 'actions',
          sortable: false,
        },
      ]
    },
  },
  created() {
    this.QXUpdateFirebaseData()
  },
  mounted() {
    // ایمنی: اگر دستگاهی نبود، اسکلتون تا نهایتاً ۱۵ ثانیه بماند
    setTimeout(() => { this.listLoading = false }, 15000)
    this.$root.$on('forceUpdate', payload => {
      if (payload.event === 'socket.devicePosition') {
        if ('imei' in payload.data) {
          this.$forceUpdate()
        }
      }
    })
  },
  methods: {
    goPage(p) {
      if (p < 1 || p > this.pageCountDeviceTable) return
      this.pageDeviceTable = p
    },
    faDigits(n) {
      return String(n).replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    },
    rowSelect(device) {
      this.mapClick(device.imei)
    },
    rowRenew(device) {
      // روی موبایل، تمدید از صفحهٔ جزییاتِ دستگاه انجام می‌شود
      this.detailClick(device.imei)
    },
    onMenuAction(payload) {
      const imei = payload.device.imei
      if (payload.action === 'detail') this.detailClick(imei)
      else if (payload.action === 'command') this.commandClick(imei)
      else if (payload.action === 'history') this.historyClick(imei)
    },
    onSendCommand(imei, commandName) {
      deviceService.sendCommand({
        imei,
        commandName,
      }).then(
        res => {
          if (res.status === 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('Message'),
                text: this.$t('An update request sent'),
                icon: 'XIcon',
                variant: 'success',
                dir: Vue.prototype.$functions.currentLangDirection(),
              },
            })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
              dir: Vue.prototype.$functions.currentLangDirection(),
            },
          })
        },
      )
    },
    QXUpdateFirebaseData() {
      UserService.updateFirebaseDataIfNeeded({})
    },
    detailClick(imei) {
      Vue.prototype.$selectDeviceDetail = imei
      this.$emit('on-change-page', 'home', 'detail', imei)
    },
    commandClick(imei) {
      Vue.prototype.$selectCommand = imei
      this.$emit('on-change-page', 'home', 'command', imei)
    },
    mapClick(imei) {
      // console.log(imei)
      this.$emit('on-change-page', 'home', 'map', imei)
    },
    historyClick(imei) {
      this.$emit('on-change-page', 'home', 'history', imei)
    },
    getDeviceOnlineStatusCssClass(imei) {
      return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].onlineStatus
    },
    isNoGpsSignal(imei) {
      return Vue.prototype.$functions.isNoGpsSignal(imei)
    },
    getStatusMovement(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.getStatusMovement(index)
    },
    getPopupInfo(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(index))
    },
    doFillDevices() {
      this.desserts = Vue.prototype.$devices
    },
    filterSearch(value) {
      this.desserts = Vue.prototype.$devices.filter(item => value.toLowerCase()
        .split(' ')
        .every(v => (item.imei || '').toLowerCase()
          .includes(v) || (item.title || '').toLowerCase()
          .includes(v)))
    },
    filterPerfectMatch(value, search, item) {
      return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search))
    },

    sinceFrom(unixTime) {
      if (!unixTime || unixTime < 1000) {
        return this.$t('Unknown')
      }
      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },
    sinceFromDevice(imei) {
      const d = this.getPopupInfo(imei)
      if (!d || !d.serverInfo) return this.$t('Unknown')
      const servertime = d.serverInfo.servertime || 0
      const statusServertime = d.serverStatus?.servertime || 0
      const lastContact = Math.max(servertime, statusServertime)
      if (!lastContact || lastContact < 1000) return this.$t('Unknown')
      return this.sinceFrom(lastContact)
    },
    buildLogoUrl(category) {
      try {
        return require(`@/assets/images/pins/cars/${this.options[category].src}.png`)
      } catch (e) {
        return require('@/assets/images/pins/cars/car.png')
      }
    },
    onAddDeviceClick() {
      router.push({ name: 'device-add' })
    },
  },
}
</script>
<style>
/* لیستِ موبایل (نسخهٔ جدید، هماهنگ با دسکتاپ) */
.devicesList .ddm-list{overflow-y:auto;overflow-x:hidden}
.devicesList .dd-empty{padding:34px 20px;text-align:center;color:#9aa0ac}
.devicesList .dd-empty-txt{margin:10px 0 0;font-size:13px;color:#9aa0ac}
.devicesList .dd-chips{display:flex;flex-wrap:wrap;gap:6px;padding:8px 12px;background:#fff}
.devicesList .dd-chip{display:inline-flex;align-items:center;gap:5px;font-size:12px;border:1px solid #ebe9f1;border-radius:20px;padding:5px 11px;color:#6e6b7b;background:#fff;font-family:inherit;cursor:pointer}
.devicesList .dd-chip-on{background:#7367f0;color:#fff;border-color:#7367f0}
.devicesList .dd-chipdot{width:9px;height:9px;border-radius:50%;display:inline-block}
.devicesList .dd-pager{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px;padding:12px;border-top:1px solid #ebe9f1;background:#fff}
.devicesList .dd-pbtn{min-width:34px;height:34px;border-radius:8px;border:1px solid #ebe9f1;background:#fff;color:#6e6b7b;font-size:13px;font-family:inherit;padding:0 8px;cursor:pointer}
.devicesList .dd-pbtn-wide{padding:0 14px}
.devicesList .dd-pbtn-on{background:#7367f0;color:#fff;border-color:#7367f0}
.devicesList .dd-pbtn:disabled{opacity:.4;cursor:default}
.devicesList .dd-pellipsis{color:#9aa0ac;padding:0 2px;align-self:center}
.devicesList .dd-skel{display:flex;align-items:center;gap:11px;padding:14px;border-bottom:1px solid #ebe9f1}
.devicesList .dd-skel-ava{width:40px;height:40px;border-radius:50%;flex:none}
.devicesList .dd-skel-lines{flex:1;display:flex;flex-direction:column;gap:8px}
.devicesList .dd-skel-ava,.devicesList .dd-skel-bar{background:linear-gradient(90deg,#eef0f3 25%,#dfe3e9 50%,#eef0f3 75%);background-size:200% 100%;animation:ddshimmer 1.2s linear infinite}
.devicesList .dd-skel-bar{height:12px;border-radius:6px}
@keyframes ddshimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}
</style>
<style>
[dir=ltr], [dir=ltr] .ltr * {
  direction: ltr !important;
  text-align: left;
}

[dir=ltr] .v-pagination__navigation {
  transform: rotateY(180deg);
}

[dir=rtl] .devicesList{
  top: 50px;
  width: 100%;
}
[dir=rtl] .devicesList .card-body{
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  padding-top: 12px !important;
}
[dir=rtl] .devicesList {
  height: 100vh;
}
[dir=rtl] .devicesList {
  z-index: 998;
  overflow-y: hidden;
  position: absolute;
  border-radius: 0;
  background: #f7f7f7;
  box-shadow: 0 0 15px rgba(0,0,0,0.55);
  clip-path: inset(0px -15px 0px 0px);
}
.devicesList .card, .devicesList .card-body {
  background: #f7f7f7;
}
[dir="rtl"] .devicesList {
  height: calc(100% - 50px);
  top: 0px;
  z-index: 99;
}
.theme--light.v-pagination .v-pagination__item--active{
  font-weight: bold;
  color: #2077ff;
}
.devicesList .v-data-table>.v-data-table__wrapper>table{
  border-collapse: separate!important;    border-spacing: 0 0.8em;    background: #f7f7f7;
}
.devicesList .v-data-table__wrapper{
  padding-bottom: 35px;
}
</style>
